import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { partnerEdit, partnerAdd, partnerDetail } from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { PartnerManage } from '@/typings/api/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { message } from '@dc-platform/dc-components'
import { contactValidate, selectForNumberValidate, concatNameValidate } from '@/utils/validate'
import CustomerArea from '@/components/CustomerArea'
import { goBack } from '@/hooks/cosRouter'
import { cloneDeep } from 'lodash-es'
import { paramCodesDataFilter } from '@/utils/index'


const __default__ = { name: 'BaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object
  },
  view: {
    type: Boolean
  },
  content: {
    type: Array,
    default: () => {
      return ['partnerBase', 'partnerContact', 'partnerActivity']
    }
  }
},
  setup(__props) {

const props = __props
const paramCodeData = ref<{
  zbu_grade_fbu: []
  zbu_partner_nature_fbu: []
  zbu_main_customers_fbu: []
  zbu_campaign_type_fbu: []
  zbu_partner_area_fbu: []
  zbu_popularity_fbu: []
  zbu_partner_role_fbu: []
}>({
  zbu_grade_fbu: [], // 评级
  zbu_partner_nature_fbu: [], // 合作伙伴性质
  zbu_main_customers_fbu: [], // 主要客群
  zbu_campaign_type_fbu: [], // 市场活动类型
  zbu_partner_area_fbu: [], // 合作伙伴区域
  zbu_popularity_fbu: [], // 知名度
  zbu_partner_role_fbu: [] // 合作伙伴角色
})
const formRef = ref()
const form = ref<PartnerManage>({
  partnerActivity: {},
  partnerContact: {}
})
const resetValue = ref<PartnerManage>({
  partnerActivity: {},
  partnerContact: {}
})

const loading = ref(false)
const route = useRoute()
const activityRequired = computed(() => {
  const { name, startTime, cost, joinFlag, areaId, resultEvaluate } = form.value.partnerActivity
  if (name || startTime || cost || joinFlag === true || joinFlag === false || areaId || resultEvaluate) {
    return true
  }
  return false
})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    partnerDetail({
      id: route.query.id,
      isForUpdate: true
    })
      .then((res) => {
        form.value = {
          ...res.data,
          partnerActivity: res.data.partnerActivity || {},
          partnerContact: res.data.partnerContact || {}
        }
        resetValue.value = cloneDeep(form.value)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: [
      'zbu_grade_fbu',
      'zbu_partner_nature_fbu',
      'zbu_main_customers_fbu',
      'zbu_campaign_type_fbu',
      'zbu_partner_area_fbu',
      'zbu_partner_role_fbu'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.view) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = {
        ...res.data
      }
    }
  })
}
const handleSubmit = async () => {
  loading.value = true
  try {
    const rParams: any = cloneDeep(form.value)
    if (!activityRequired.value) {
      console.log(form.value)
      const { partnerActivity } = form.value
      if (partnerActivity) {
        if (partnerActivity.id) {
          rParams.partnerActivity = {
            id: partnerActivity.id
          }
        } else {
          delete rParams.partnerActivity
        }
      }
    }
    if (route.query.id) {
      await partnerEdit(rParams)
      message.success('编辑成功')
    } else {
      await partnerAdd(rParams)
      message.success('新增成功')
    }
    goBack()
    // router.push({
    //   path: '/zbu/partnerManage'
    // })
  } catch (error) {}
  loading.value = false
}
onMounted(() => {
  fetch()
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      name: "detailsForm",
      ref_key: "formRef",
      ref: formRef,
      model: form.value
    }, {
      default: _withCtx(() => [
        (__props.content.includes('partnerBase'))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "基本信息"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "合作伙伴名称",
                  name: "name",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "评级",
                  name: "starGrade",
                  rules: { required: true, validator: _unref(selectForNumberValidate), message: '请选择' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.starGrade,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.starGrade) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      options: _unref(dataConfig).starGrade,
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "知名度",
                  name: "popularityDegree",
                  rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.popularityDegree,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.popularityDegree) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      options: [...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 })),
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "契合度",
                  name: "agreementDegree",
                  rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.agreementDegree,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.agreementDegree) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      options: [...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 })),
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "关系",
                  name: "relationDegree",
                  rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.relationDegree,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.relationDegree) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      options: [...Array(10)].map((_, i) => ({ value: i + 1, label: i + 1 })),
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "合作伙伴区域",
                  name: "regionId",
                  rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.zbu_partner_area_fbu,
                      value: form.value.regionId,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.regionId) = $event)),
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["options", "value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "Base地",
                  name: "areaId",
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CustomerArea), {
                      value: form.value.areaId,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.areaId) = $event)),
                      label: form.value.areaName,
                      "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((form.value.areaName) = $event)),
                      disabled: __props.disabled,
                      "change-on-select": "",
                      view: __props.view
                    }, null, 8, ["value", "label", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "性质",
                  name: "property",
                  rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.zbu_partner_nature_fbu,
                      value: form.value.property,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.property) = $event)),
                      disabled: __props.disabled,
                      filterNoVal: "",
                      view: __props.view
                    }, null, 8, ["options", "value", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "主要客群",
                  name: "mainCustomers",
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.zbu_main_customers_fbu,
                      value: form.value.mainCustomers,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.mainCustomers) = $event)),
                      disabled: __props.disabled,
                      mode: "multiple",
                      view: __props.view
                    }, null, 8, ["options", "value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "市场活动类型",
                  name: "activityTypes",
                  rules: [{ required: true, message: '请选择' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.zbu_campaign_type_fbu,
                      value: form.value.activityTypes,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.activityTypes) = $event)),
                      disabled: __props.disabled,
                      mode: "multiple",
                      view: __props.view
                    }, null, 8, ["options", "value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "市场活动计划",
                  name: "activityPlan"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.activityPlan,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.activityPlan) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "网站/公众号",
                  name: "webSite"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.webSite,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.webSite) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "合作伙伴简介",
                  name: "intro",
                  span: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosTextarea, {
                      value: form.value.intro,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.intro) = $event)),
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      view: __props.view
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.content.includes('partnerContact'))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 1,
              title: "对接人信息"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "对接人名称",
                  name: ['partnerContact', 'name'],
                  rules: [{ required: true, message: '请输入' }, { validator: _unref(concatNameValidate) }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.name,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.partnerContact.name) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "性别",
                  name: "sex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.partnerContact.sex,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.partnerContact.sex) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      options: _unref(dataConfig).genderEnum,
                      disabled: __props.disabled,
                      filterNoVal: ""
                    }, null, 8, ["value", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "角色",
                  name: "role"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.zbu_partner_role_fbu,
                      value: form.value.partnerContact.role,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.partnerContact.role) = $event)),
                      disabled: __props.disabled,
                      filterNoVal: ""
                    }, null, 8, ["options", "value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "手机",
                  name: ['partnerContact', 'mobile'],
                  rules: [{ validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.partnerContact, formRef.value) }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.mobile,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.partnerContact.mobile) = $event)),
                      allowClear: "",
                      placeholder: "请输入，联系方式必填其一",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "邮箱",
                  name: ['partnerContact', 'email'],
                  rules: [
          {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.partnerContact, formRef.value)
          }
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.email,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.partnerContact.email) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入，联系方式必填其一",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "微信号",
                  name: ['partnerContact', 'wechat'],
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.partnerContact, formRef.value)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.wechat,
                      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.partnerContact.wechat) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入，联系方式必填其一",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "QQ号",
                  name: ['partnerContact', 'qq'],
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.partnerContact, formRef.value),
          trigger: 'blur'
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.qq,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.partnerContact.qq) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入，联系方式必填其一",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "固定电话",
                  name: ['partnerContact', 'tel'],
                  rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.partnerContact, formRef.value)
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerContact.tel,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.partnerContact.tel) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入，联系方式必填其一",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_col, { span: 24 }),
                _createVNode(_component_dc_form_item, {
                  label: "备注",
                  name: "remark",
                  span: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosTextarea, {
                      value: form.value.partnerContact.remark,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.partnerContact.remark) = $event)),
                      maxlength: 2000,
                      placeholder: "请输入",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.content.includes('partnerActivity'))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 2,
              title: "市场活动信息"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "活动名称",
                  name: ['partnerActivity', 'name'],
                  rules: [{ required: activityRequired.value, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.partnerActivity.name,
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.partnerActivity.name) = $event)),
                      valueModifiers: { trim: true },
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "活动时间",
                  name: "time"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_cos_range_picker, {
                      startTime: form.value.partnerActivity.startTime,
                      "onUpdate:startTime": _cache[24] || (_cache[24] = ($event: any) => ((form.value.partnerActivity.startTime) = $event)),
                      endTime: form.value.partnerActivity.endTime,
                      "onUpdate:endTime": _cache[25] || (_cache[25] = ($event: any) => ((form.value.partnerActivity.endTime) = $event)),
                      disabled: __props.disabled
                    }, null, 8, ["startTime", "endTime", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  label: "活动费用",
                  name: ['partnerActivity', 'cost'],
                  rules: [{ required: activityRequired.value, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInputNumber, {
                      value: form.value.partnerActivity.cost,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.partnerActivity.cost) = $event)),
                      maxlength: 15,
                      min: 0,
                      precision: 2,
                      allowClear: "",
                      placeholder: "请输入",
                      disabled: __props.disabled,
                      style: {"width":"100%"}
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "是否参加",
                  name: ['partnerActivity', 'joinFlag'],
                  rules: [{ required: activityRequired.value, message: '请选择', validator: _unref(selectForNumberValidate) }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: form.value.partnerActivity.joinFlag,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.partnerActivity.joinFlag) = $event)),
                      allowClear: "",
                      placeholder: "请选择",
                      disabled: __props.disabled,
                      options: _unref(dataConfig).joinFlag
                    }, null, 8, ["value", "disabled", "options"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_dc_form_item, {
                  label: "活动区域",
                  name: "areaId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CustomerArea), {
                      value: form.value.partnerActivity.areaId,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.partnerActivity.areaId) = $event)),
                      label: form.value.partnerActivity.areaName,
                      "onUpdate:label": _cache[29] || (_cache[29] = ($event: any) => ((form.value.partnerActivity.areaName) = $event)),
                      "change-on-select": "",
                      disabled: __props.disabled
                    }, null, 8, ["value", "label", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 18 }),
                _createVNode(_component_dc_form_item, {
                  label: "活动效果评估",
                  name: "resultEvaluate",
                  span: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosTextarea, {
                      value: form.value.partnerActivity.resultEvaluate,
                      "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((form.value.partnerActivity.resultEvaluate) = $event)),
                      maxlength: 2000,
                      placeholder: "请输入",
                      disabled: __props.disabled
                    }, null, 8, ["value", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: form.value,
      "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((form).value = $event)),
      resetValue: resetValue.value,
      formRef: formRef.value,
      permissionPage: __props.permissionPage,
      loading: loading.value,
      editUrl: `/fbu/partnerManage/edit?id=${_unref(route).query.id}`,
      onSubmit: handleSubmit,
      disabled: __props.disabled
    }, null, 8, ["value", "resetValue", "formRef", "permissionPage", "loading", "editUrl", "disabled"])
  ], 64))
}
}

})